import React from 'react';
import Modal from 'components/molecules/Modal';
import PanelDescription from 'components/atoms/PanelDescription';

export enum ActionType {
  CREATE = 0,
  UPDATE = 1,
  DELETE = 2,
  IMPORT = 3,
}
/**
 * Confirm action for add, delete, update
 */
export enum ActionDelete {
  STAFF = 'staff'
}

const ConfirmActionModal: React.FC<{
  open: boolean
  closeHandler: () => void
  onSubmit: () => void
  actionType: ActionType
  typeSubmit?: string,
  actionDelete?: ActionDelete
}> = ({
  open, closeHandler, onSubmit, actionType, typeSubmit, actionDelete
}) => {
  let content = '';
  let submitText = '';
  let title = '確認メッセージ';
  if (actionType === ActionType.CREATE) {
    content = '登録します。よろしいですか？';
    submitText = '登録';
  } else if (actionType === ActionType.DELETE) {
    content = '削除します。よろしいですか？';
    submitText = '削除';
  } else if (actionType === ActionType.UPDATE) {
    content = '更新します。よろしいですか？';
    submitText = '更新';
  } else if (actionType === ActionType.IMPORT) {
    title = 'ファイルをアップロード';
    content = 'ファイルをアップロードします。よろしいですか？';
    submitText = 'アップロード';
  }

  if(actionDelete === ActionDelete.STAFF) {
    content = 'スタッフ情報を削除します。よろしいですか？';
    submitText = '削除';
  }


  return (
    <Modal
      open={open}
      closeHandler={closeHandler}
      title={title}
      submitText={submitText}
      onSubmit={onSubmit}
      typeSubmit={typeSubmit}
    >
      <PanelDescription>
        {content}
      </PanelDescription>
    </Modal>
  );
};

export default ConfirmActionModal;
